module.exports = __webpack_public_path__ + "static/img/szafa_22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_22.svg
// module id = top4
// module chunks = 0